// extracted by mini-css-extract-plugin
module.exports = {"img":"product-badge_img__8aUhN","product":"product-badge_product__CckRw product-badge_img__8aUhN","course":"product-badge_course__1SmgZ product-badge_img__8aUhN"};